import { render } from "./CfChart.vue?vue&type=template&id=303f7a24"
import script from "./CfChart.vue?vue&type=script&lang=js"
export * from "./CfChart.vue?vue&type=script&lang=js"

import exportComponent from "D:\\root\\baam\\viribuz\\viribuz-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__